var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9B8183A0-BC2F-4B2F-891C-934BFB26E6A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---13---View-details--1",
    transform: "translate(-762.000000, -586.000000)",
    fill: "#46B39A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(223.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(30.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(0.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36-Copy",
    transform: "translate(509.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-tick-801900-copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6396035,0.0075617182 C5.00061364,0.0075617182 0.42558414,4.58259122 0.42558414,10.2215811 C0.42558414,15.8605709 5.00061364,20.4356004 10.6396035,20.4356004 C16.2785933,20.4356004 20.8536228,15.8605709 20.8536228,10.2215811 C20.8536228,4.58259122 16.2785933,0.0075617182 10.6396035,0.0075617182 Z M15.8955676,7.75319306 L9.89483125,13.7752086 C9.70335258,13.9666873 9.42668869,14.0943359 9.14998301,14.0943359 C8.87327732,14.0943359 8.59676162,13.9879095 8.40513477,13.7752086 L5.38363937,10.7535612 C4.95809323,10.3280151 4.95809323,9.66835969 5.38363937,9.24266155 C5.80918551,8.81711541 6.46884093,8.81711541 6.89453906,9.24266155 L9.150097,11.4982195 L14.4060611,6.24225537 C14.8316073,5.81670923 15.4912627,5.81670923 15.9169608,6.24225537 C16.3211518,6.6679535 16.3211518,7.32757092 15.8955866,7.75315506 L15.8955676,7.75319306 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.1f7187a07be7141161265124bb5f761d.svg";
export { ForwardRef as ReactComponent };